/**
 * 流水线自动注入环境变量，用来区分多set和线上/测试环境
 */

const SET_ENV = '';
const MODE = 'production';
const actionShowConfig = [];

module.exports = {
  SET_ENV,
  MODE,
  actionShowConfig,
};
